﻿/*!
trc.simgate.js v0.2.0 07/31/2017 Copyright (c) 2013,2017 The Regis Company, Inc. All Rights Reserved.
For details and terms of use please visit: http://www.regiscompany.com
*/
define([], function () {
    var _FILE_ = "trc.simgate: ",
        _U_ = "undefined",
        _B_ = "boolean",
        _F_ = "function",
        _O_ = "object",
        _S_ = "string",
        _CNT_ = "content",
        _HDR_CT_ = "Content-Type",
        _HDR_CL_ = "Content-Length",
        _HDR_CD_ = "Content-Disposition",
        _HDR_CFS_ = "x-simgate-file-size",
        _CT_JSON_ = "application/json",
        _CT_FORM_ = "multipart/form-data",
        _CT_TEXT_ = "text/plain; charset=utf-8",
        _CT_CROSS_ = [_CT_TEXT_, "application/x-www-form-urlencoded", _CT_FORM_],
        _REQ_ = "simgate-request",
        _WebRequestQueue_ = [],
        _XhrSpecialOptions = ["withCredentials", "user", "password", "delay"],
        _XhrEvents = [
            ["done", "success", "complete"],
            ["fail", "error", "catch"],
            ["abort", "cancel"],
            ["timeout", "timeOut"],
            ["always", "after"]
        ];

    function _void() {
    }

    function _isNull(v) {
        return (v === null || typeof v === _U_ || typeof v === "unknown");
    }

    function _isObj(o) {
        return (!_isNull(o) && (typeof o === _O_));
    }

    function _isArray(a) {
        return (_isObj(a) && ((a instanceof Array) || (a.constructor == Array) || !isNaN(a.length)));
    }

    function _int(v) {
        var n = parseInt(v);
        return isNaN(n) ? (arguments.length > 1 ? arguments[1] : NaN) : n;
    }

    function _date(src) {
        var d = new Date();
        d.setTime((src ? src.getTime() : 0));
        return d;
    }

    function _getProp(o, p, remove) {
        var v = null;
        try {
            if (o) {
                v = o[p];
                if (remove) {
                    delete o[p];
                }
                if (typeof v === _U_) {
                    v = null;
                }
            }
        }
        catch (e) {
        }
        return v;
    }

    function _delete(obj, prop) {
        if (_isObj(obj) && prop) {
            try {
                if (typeof prop === _S_) {
                    delete obj[prop];
                }
                else {
                    for (var i = 0, l = prop.length; i < l; i++) {
                        delete obj[prop[i]];
                    }
                }
            }
            catch (err) {

            }
        }
        return obj;
    }

    function _merge(dest, src) {
        if (src) {
            if (_isNull(dest)) {
                dest = src;
                return dest;
            }

            var s, st, d, dt;
            for (var prop in src) {
                s = src[prop];
                if (_isNull(s)) {
                    dest[prop] = s;
                }
                else {
                    d = dest[prop];
                    dt = typeof d;
                    st = typeof s;
                    switch (st) {
                        case _O_:
                            if (dt === _S_) { //s + o = o
                                if (!s.hasOwnProperty("value")) {
                                    s = _clone(s);
                                    s.value = d;
                                }
                            }
                            else {
                                if (s instanceof Date) {
                                    s = _date(s);
                                }
                                else {
                                    s = _merge(d, s);
                                }
                            }
                            break;

                        case _S_:
                            if (dt === _O_ && !_isNull(d)) { // o + s = o
                                dest[prop].value = s;
                                continue;
                            }
                            break;
                    }
                    dest[prop] = s;
                }
            }
        }
        return dest;
    }

    function _clone(value) {
        if (!value) {
            return value;
        }

        switch (typeof value) {
            case _U_:
                return undefined;

            case _S_:
                value = value.substring(0);
                for (var i = 1; i < arguments.length; i++) {
                    value += arguments[i];
                }
                return value;

            case "symbol": // ECMA2015
                return new Symbol(value);

            case _O_:
                if (value instanceof Date) {
                    return _date(value);
                }
                if (_isArray(value)) {
                    var array = [];
                    for (var i = -1, len = value.length; ++i < len;) {
                        array.push(_clone(value[i]));
                    }
                    return array;
                }
                var obj = {}, p;
                for (p in value) {
                    obj[p] = _clone(value[p]);
                }
                if (arguments.length > 1) {
                    obj = _merge(obj, arguments[1]);
                }
                return obj;
        }
        return value;
    }

    function _ab2Str(buffer, encoding) {
        if (!encoding) {
            encoding = "";
        }
        switch (encoding) {
            case "":
            case "utf-8":
                encoding = Uint8Array;
                break;
            case "utf-16":
                encoding = Uint8Array; //Uint16Array;
                break;
            case "utf-32":
                encoding = Uint8Array; //Uint32Array;
                break;
            default:
                throw new Error("Unsupported encoding " + encoding);
        }
        var bytes = new encoding(buffer), str = "";
        for (var i = 0, len = bytes.length; i < len; i++) {
            str += ("%" + ("00" + bytes[i].toString(16)).slice(-2));
        }
        return decodeURIComponent(str);
    }

    function _getMethod(obj, names, remove) {
        var m = null;
        if (obj && names) {
            if (!_isArray(names)) {
                names = [names.toString()];
            }
            for (var i = 0, n; i < names.length; i++) {
                n = names[i];
                if (typeof obj[n] === _F_) {
                    m = obj[n];
                    if (remove === 1) {
                        delete obj[n];
                        remove = false;
                    }
                    break;
                }
            }
            if (remove === true || remove > 1) {
                _delete(obj, names);
            }
        }
        return m;
    }

    function ContentType(header) {
        this.contentType = null;
        this.encoding = null;

        if (header) {
            header = header.toLowerCase().split(/\s*;\s*/);
            this.contentType = header[0];
            if (header.length > 1) {
                header = header[1].split(/\s*=\s*/);
                this.encoding = header[(header.length > 1 ? 1 : 0)];
            }
        }
    }

    function toJson(obj) {
        return (obj === null || obj === undefined) ? "null" : JSON.stringify(obj);
    }

    function parseJSON(json) {
        return json ? JSON.parse(json) : null;
    }

    function FileInfo(name, type, length, disp) {
        this.filename = name;
        this.type = type;
        this.length = _int(length, null);
        this.disposition = disp;
    }

    function WebRequest(req, trace) {
        var self = this,
            _xhr = null,
            _handlers = {},
            _isResolved = false,
            _trace = trace,
            _traceResp = _void,
            _traceError = _void;

        this.url = null;
        this.xhrParsers = [];
        this.result = null;

        if (_trace) {
            _traceResp = function (prop, value) {
                _trace.response = _trace.response || {};
                _trace.response[prop] = value;
            };

            _traceError = function (err) {
                _traceResp("error", err);
            };
        }

        _merge(this, req);

        this.headers = this.headers || {};
        if (this.nocache) {
            this.headers["Cache-Control"] = "no-cache";
        }
        delete this.nocache;

        function _error(err) {
            if (!_isResolved) {
                _traceError(err);
                if (_handlers.fail) {
                    _handlers.fail.call(self, err, _xhr);
                }
            }
        }

        function _onError() {
            var message = "Request error.",
                statusCode = 0;
            if (_xhr) {
                statusCode = _xhr.status;
                message = "Status code: " + (statusCode ? statusCode : "<unknown>");
                if (_xhr.statusText) {
                    message += ("\nStatus description: " + _xhr.statusText);
                }
                if (_xhr.responseText) {
                    message += ("\nResponse: " + _xhr.responseText);
                }
            }
            if (console && console.log) {
                console.log("Simgate error: " + message);
            }
            var err = new Error(message);
            err.request = _xhr;
            err.number = statusCode;
            _error(err);
        }

        function _onAbort() {
            if (!_isResolved) {
                _traceResp("abort", true);
                var err = new Error("Request aborted.");
                if (_handlers.abort) {
                    _traceError(err);
                    _handlers.abort.call(self, _xhr);
                }
                else {
                    _error(err);
                }
            }
        }

        function _onTimeout() {
            if (!_isResolved) {
                var err = new Error("Request timed out.");
                _traceResp("timeout", true);
                if (_handlers.timeout) {
                    _traceError(err);
                    _handlers.timeout.call(self, _xhr);
                }
                else {
                    _error(err);
                }
            }
        }

        function _parseResponse(xhr) {
            var status = xhr.status,
                message = xhr.statusText,
                description = xhr.responseText,
                res = null;

            try {
                var ct = new ContentType(xhr.getResponseHeader("content-type")), json = null;
                switch (ct.contentType) {
                    case _CT_JSON_:
                    case "application/javascript":
                    case "application/x-javascript":
                    case "text/javascript":
                        if (ArrayBuffer && (xhr.response instanceof ArrayBuffer)) {
                            json = _ab2Str(xhr.response, ct.encoding);
                        }
                        else {
                            json = _getProp(xhr, "responseText");
                            if (!json) {
                                json = _getProp(xhr, "responseJSON");
                            }
                        }
                        break;

                    case "text/plain":
                    default:
                        if (ArrayBuffer && (xhr.response instanceof ArrayBuffer)) {
                            json = _ab2Str(xhr.response, ct.encoding);
                        }
                        else {
                            json = _getProp(xhr, "responseJSON"); //jquery ajax
                        }
                        break;
                }

                if (status < 200 || status >= 300 || (message || "").toLowerCase().indexOf("simgate server error") != -1) { // http/server error
                    var data = parseJSON(json);
                    if (data && data.error) {
                        message = data.error.message;
                        status = data.error.number;
                        description = data.error.description;
                    }
                    res = new Error(message);
                    res.number = status;
                    if (description) {
                        res.description = description;
                    }
                }
                else {
                    var file = xhr.getResponseHeader(_HDR_CD_);
                    if (file) {
                        var fileName = /filename\s*=\s*((['"]).*?\2|[^;\n\r]*)/.exec(file);
                        file = /([^;]\w+);/.exec(file);
                        file = new FileInfo(
                            ((fileName && fileName[1]) ? fileName[1].toString() : "document"),
                            xhr.getResponseHeader(_HDR_CT_),
                            xhr.getResponseHeader(_HDR_CL_) || xhr.getResponseHeader(_HDR_CFS_),
                            ((file && file[1]) ? file[1].toString().toLowerCase() : "attachment")
                        );
                        return file; //this it??
                    }

                    res = parseJSON(json);
                    if (res) {
                        if (res.hasOwnProperty("d")) {
                            res = res.d;
                        }
                        if (res) {
                            if (res.hasOwnProperty("error")) {
                                throw res.error;
                            }
                            if (res.hasOwnProperty("result")) {
                                res = res.result;
                            }
                        }
                    }
                }
            }
            catch (err) {
                res = err;
                res.response = xhr;
            }
            return res;
        }

        function _onLoad() {
            try {
                if (this.readyState !== 4) {
                    return;
                }

                _traceResp("status", this.status);

                self.result = _parseResponse(_xhr);

                if (self.result instanceof Error) {
                    throw self.result;
                }

                if (self.xhrParsers) {
                    for (var i in self.xhrParsers) {
                        var p = self.xhrParsers[i];
                        if ((typeof p === _F_) && p.call(self, self.result, _xhr) === false) {
                            break;
                        }
                    }
                }
                if (!_isResolved && _handlers.done) {
                    _handlers.done.call(self, self.result, _xhr);
                }
            }
            catch (error) {
                if (!_isResolved) {
                    _traceError(error);
                    if (_handlers.fail) {
                        _handlers.fail.call(self, error, _xhr);
                    }
                }
            }
            finally {
                if (!_isResolved) {
                    self.resolve(true);
                    if (_handlers.always) {
                        _handlers.always.call(self, _xhr);
                    }
                }
            }
        }

        //#region Event handlers
        for (var i = 0, et, en; i < _XhrEvents.length; i++) {
            et = _XhrEvents[i];
            en = et[0];
            _handlers[en] = _getMethod(this, et, true);
            for (var j = 0; j < et.length; j++) {
                (function (f) {
                    self[et[j]] = function (cb) {
                        if (typeof cb === _F_) {
                            _handlers[f] = cb;
                        }
                        return self;
                    };
                })(en);
            }
        }

        this.before = function (f) {
            if (typeof f === _F_) {
                _handlers.before = f;
            }
            return self;
        };

        this.then = function (d, f, a) {
            if (typeof d === _F_) {
                _handlers.done = d;
            }
            if (typeof f === _F_) {
                _handlers.fail = f;
            }
            if (typeof a === _F_) {
                _handlers.always = a;
            }
            return self;
        };
        //#endregion

        this.send = function (options) {
            var method = self.method || "POST",
                delay = 7; //7 ms.

            _xhr = new XMLHttpRequest();
            _xhr.addEventListener("error", _onError);
            _xhr.addEventListener("abort", _onAbort);
            _xhr.addEventListener("load", _onLoad);
            _xhr.addEventListener("timeout", _onTimeout);

            options = options || {};
            method = options.method || method;
            if (typeof options.withCredentials !== _U_) {
                _xhr.withCredentials = !!options.withCredentials;
            }
            if (_xhr.withCredentials || options.user || options.password) {
                _xhr.open(method, self.url, true, options.user || "", options.password || "");
            }
            else {
                _xhr.open(method, self.url);
            }

            //setup xhr headers
            if (self.headers) {
                for (var h in self.headers) {
                    _xhr.setRequestHeader(h, self.headers[h]);
                }
            }

            //setup additional xhr parameters if any (skip special options)
            for (var o in options) {
                if (_XhrSpecialOptions.indexOf(o) == -1) {
                    _xhr[o] = options[o];
                }
            }
            if (options.delay > 7) {
                delay = _int(options.delay);
            }

            setTimeout(function () {
                var s = ((typeof _handlers.before === _F_) && _handlers.before.call(self, _xhr) === false) ? false : true;
                if (s === true) {
                    try {
                        _xhr.send(self.data);
                    }
                    catch (err) {
                        _error(err);
                    }
                }
            }, delay);
            return self;
        };

        this.resolve = function () {
            if (arguments.length > 0) {
                _isResolved = (typeof arguments[0] === _B_) ? arguments[0] : _isResolved;
                var p = _WebRequestQueue_.indexOf(self);
                if (_isResolved) {
                    if (p != -1) {
                        _WebRequestQueue_.splice(p, 1);
                    }
                }
                else {
                    if (p == -1) {
                        _WebRequestQueue_.push(self);
                    }
                }
            }
            return _isResolved;
        };

        this.abortRequest = function () {
            if (_xhr && !_isResolved && (_xhr.state == 2 || _xhr.state == 3)) {
                _xhr.abort();
            }
        };

        _WebRequestQueue_.push(this);
    }

    function SimgateContext(src) {
        this.userId = 0;
        this.roleId = 0;
        this.user = null;
        this.path = null;
		_merge(this, src);
    }

    SimgateContext.isContext = function (o) {
        return (o instanceof SimgateContext);
    };

    function _createTF(filter) {
        filter = filter.split(/\//gi);
        if (filter.length > 1) {
            if (!filter[0]) {
                filter[0] = "*";
            }
            if (filter.length > 2 && !filter[1]) {
                filter[1] = "*";
            }
            filter = filter.join("/");
        }
        else {
            filter = filter[0];
        }
        filter = filter.replace(/\*/g, "[-\\w]+").replace(/\//gi, "\\/");
        return new RegExp(filter, "i");
    }

    function _testTF(trace, filter) {
        return (trace && (!filter || (trace.req && filter.test(trace.req.url))));
    }

    function Simgate(configuration) {
        var self = this,
            _traceData = [];

        if (typeof configuration === _F_) {
            configuration = new configuration();
        }

        this.url = "";
        this.apiUrl = "";
        this.context = new SimgateContext();
        this.trace = { limit: 0 };
        this.options = {};
        this.crossDomain = false;
        this.onError = function (error) {
            var msg = Error.format(error);
            if (msg) {
                Error.trace(_FILE_, msg);
                alert(_FILE_ + msg);
            }
        };

        _merge(this, configuration);

        this.url = this.url ? this.url.replace(/\/$/gi, "") : "";
        if (!this.apiUrl) {
            this.apiUrl = this.url + "/api/simgate";
        }
        this.crossDomain = !!this.crossDomain;

        this.setContext = function (ctx) {
			if (!SimgateContext.isContext(self.context)) {
				self.context = new SimgateContext(self.context);
			}
			_merge(self.context, ctx);
            return self;
        };

        this.clearContext = function () {
            self.context = new SimgateContext();
        };

        this.createTrace = function (req) {
            if (self.trace.limit > 0) { //["path/select""]
                var t = {
                    time: new Date(),
                    url: req.url,
                    data: req.data
                };
                if (_traceData.length > 0) {
                    var over = _traceData.length - self.trace.limit;
                    if (over >= 0) {
                        _traceData.splice(0, over + 1);
                    }
                }
                _traceData.push(t);
                return t;
            }
            return null;
        };

        this.selectTrace = function (filter) {
            if (!filter) {
                return _traceData;
            }
            filter = _createTF(filter);
            var filtered = [];
            for (var i = 0; i < _traceData.length; i++) {
                if (_testTF(_traceData[i], filter)) {
                    filtered.push(_traceData[i]);
                }
            }
            return filtered;
        };

        this.deleteTrace = function (filter) {
            if (_traceData.length > 0) {
                if (!filter) {
                    _traceData = [];
                }
                else {
                    filter = _createTF(filter);
                    for (var i = _traceData.length; --i > -1;) {
                        if (_testTF(_traceData[i], filter)) {
                            _traceData.splice(i, 1);
                        }
                    }
                }
            }
            return _traceData;
        };

        self.fetch = function (url, request) {
            if (!url) {
                throw new Error("Invalid argument 'url'");
            }

            var xhrHeaders = _getProp(request, "xhrHeaders", true),
                contentType = _getProp(request, "contentType", true),
                options = _clone(self.options, _getProp(request, "xhrOptions", true)),
                parsers = _getProp(request, "xhrParsers", true),
                isFormData = (request instanceof FormData);

            if (self.crossDomain) {
                if (contentType) {
                    contentType = contentType.toLowerCase();
                    var i = 0, ct, len = contentType.length;
                    for (; i < _CT_CROSS_.length; i++) {
						ct = _CT_CROSS_[i];
                        if (ct && len >= ct.length && contentType.substring(0, ct.length) === ct) {
                            break;
                        }
                    }
                    if (i >= 3) {
                        throw new Error(_HDR_CT_ + " '" + contentType + "' is not allowed in cross-domain mode.");
                    }
                    if (!isFormData) {
                        request = toJson(request);
                    }
                }
                else {
                    if (!isFormData) {
                        contentType = _CT_TEXT_;
                        request = toJson(request);
                    }
                }
                options = options || {};
                if (!options.hasOwnProperty("withCredentials")) {
                    options.withCredentials = true; // by default true otherwise auth. cookie won't be sent
                }
            }
            else {
                if (!contentType) {
                    if (isFormData) {
                        contentType = _CT_FORM_;
                    }
                    else {
                        contentType = _CT_JSON_;
                        request = toJson(request);
                    }
                }
            }

            if (contentType) {
                xhrHeaders = xhrHeaders || {};
                xhrHeaders[_HDR_CT_] = contentType;
            }
            var req = {
                url: url,
                data: request
            };
            if (xhrHeaders) {
                req.headers = xhrHeaders;
            }
            if (parsers) {
                req.xhrParsers = parsers;
            }
            return (new WebRequest(req, self.createTrace(req))).send(options);
        };

		function _addParser(r) {
			r = r || {};
			r.xhrParsers = (r.xhrParsers || []);
			r.xhrParsers.push(syncCtx);
			return r;
		}

		function _fetch(url, data, options) {
		    return self.fetch(self.apiUrl + "/" + url, data || {}, options);
		}

        //#region Security API
		function syncCtx(r) {
			if (r) {
				self.setContext(r.context);
			}
		}
        this.security = {
            signIn: function (d, o) { return _fetch("security/signIn", _addParser(d, syncCtx), o); },
            signOut: function (d, o) { return _fetch("security/signOut", d, o); },
            getContext: function (d, o) { return _fetch("security/getContext", d, o); },
            register: function (d, o) { return _fetch("security/register", d, o); },
            changePassword: function (d, o) { return _fetch("security/changePassword", d, o); },
            resetPassword: function (d, o) { return _fetch("security/resetPassword", d, o); },
            forgotPassword: function (d, o) { return _fetch("security/forgotPassword", d, o); }
        };
        this.signIn = this.security.signIn;
        this.signOut = this.security.signOut;
        this.getContext = this.security.getContext;
        this.register = this.security.register;
        this.changePassword = this.security.changePassword;
        this.resetPassword = this.security.resetPassword;
        this.forgotPassword = this.security.forgotPassword;
        //#endregion

        //#region Configuration API
        this.config = {
            select: function (d, o) { return _fetch("config/select", d, o); },
            create: function (d, o) { return _fetch("config/create", d, o); },
            update: function (d, o) { return _fetch("config/update", d, o); },
            delete: function (d, o) { return _fetch("config/delete", d, o); },
            reviews: function (d, o) { return _fetch("config/reviews", d, o); },
            trim: function (d, o) { return _fetch("config/trim", d, o); },
            commit: function (d, o) { return _fetch("config/commit", d, o); },
            revert: function (d, o) { return _fetch("config/revert", d, o); }
        };
        //#endregion

        //#region User API
        this.user = {
            select: function (d, o) { return _fetch("user/select", d, o); },
            create: function (d, o) { return _fetch("user/create", d, o); },
            update: function (d, o) { return _fetch("user/update", d, o); },
            delete: function (d, o) { return _fetch("user/delete", d, o); }
        };
        this.selectUser = this.user.select;
        this.createUser = this.user.create;
        this.updateUser = this.user.update;
        this.deleteUser = this.user.delete;
        //#endregion

        //#region Path API
        this.path = {
            select: function (d, o) { return _fetch("path/select", d, o); },
            create: function (d, o) { return _fetch("path/create", d, o); },
            update: function (d, o) { return _fetch("path/update", d, o); },
            delete: function (d, o) { return _fetch("path/delete", d, o); }
        };
        this.selectPath = this.path.select;
        this.createPath = this.path.create;
        this.updatePath = this.path.update;
        this.deletePath = this.path.delete;
        //#endregion

        //#region Session API
        this.session = {
            select: function (d, o) { return _fetch("session/select", d, o); },
            create: function (d, o) { return _fetch("session/create", d, o); },
            update: function (d, o) { return _fetch("session/update", d, o); },
            delete: function (d, o) { return _fetch("session/delete", d, o); }
        };
        this.selectSession = this.session.select;
        this.createSession = this.session.create;
        this.updateSession = this.session.update;
        this.deleteSession = this.session.delete;
        //#endregion

        //#region Team API
        this.team = {
            select: function (d, o) { return _fetch("team/select", d, o); },
            create: function (d, o) { return _fetch("team/create", d, o); },
            update: function (d, o) { return _fetch("team/update", d, o); },
            delete: function (d, o) { return _fetch("team/delete", d, o); },
            reset: function (d, o) { return _fetch("team/reset", d, o); },
            takeControl: function (d, o) { return _fetch("team/takeControl", d, o); },
            releaseControl: function (d, o) { return _fetch("team/releaseControl", d, o); },
            transition: function (d, o) { return _fetch("team/transition", d, o); },
            execute: function (d, o) { return _fetch("team/execCommand", d, o); }
        };
        this.selectTeam = this.team.select;
        this.createTeam = this.team.create;
        this.updateTeam = this.team.update;
        this.deleteTeam = this.team.delete;
        this.resetTeam = this.team.reset;
        this.takeControl = this.team.takeControl;
        this.releaseControl = this.team.releaseControl;
        this.transitionTeam = this.team.transition;
        this.execCommand = this.team.execute;
        //#endregion

        //#region Data API
        this.data = {
            select: function (d, o) { return _fetch("data/select", d, o); },
            update: function (d, o) { return _fetch("data/update", d, o); },
            execQuery: function (d, o) { return _fetch("data/execQuery", d, o); },
            runModel: function (d, o) { return _fetch("data/runModel", d, o); }
        };
        this.selectData = this.data.select;
        this.updateData = this.data.update;
		this.execQuery = this.data.execQuery;
		this.runModel = this.data.runModel;
        //#endregion

        //#region Document API
        function addDocContent(formData, doc, prop, index) {
            if (_isObj(doc)) {
                var content = doc[prop];
                if (content instanceof File) {
                    doc[prop] = null;
                    formData.append("form-file" + (index === undefined ? "" : index.toString()), content);
                }
            }
            return formData;
        }

        this.document = {
            select: function (d, o) { return _fetch("document/select", d, o); },
            create: function (r, o) {
                var formData = new FormData(),
                    create = r.create;
                if (!_isArray(create)) {
                    create = [create];
                }
                r.create = create;
                for (var i = 0; i < create.length; i++) {
                    addDocContent(formData, create[i], _CNT_, i);
                }
                formData.append(_REQ_, toJson(r));
                return _fetch("document/create", formData, o);
            },
            update: function (d, o) {
                var data = addDocContent(new FormData(), (d || {}).set, _CNT_);
                data.append(_REQ_, toJson(d));
                return _fetch("document/update", data, o);
            },
            delete: function (d, o) {
                return _fetch("document/delete", d, o);
            },
            commit: function (d, o) {
                var data = addDocContent(new FormData(), d, "file");
                data.append(_REQ_, toJson(d));
                return _fetch("document/commit", data, o);
            },
            download: function (r, o) {
                r = r || {};
                r.xhrOptions = r.xhrOptions || {};
                r.xhrOptions.responseType = "arraybuffer";
                if (!_isArray(r.responseParser)) {
                    r.xhrParsers = [];
                }
                r.xhrParsers.push(function (res, xhr) {
                    if (!(res instanceof FileInfo)) {
                        throw new Error("Server response has no file information.");
                    }
                    if (res.saved) {
                        return;
                    }
                    res.saved = true;
                    if (!res.filename) {
                        res.filename = "document";
                    }
                    var blob = new Blob([xhr.response], { type: res.type });
                    if (typeof window.navigator.msSaveOrOpenBlob != _U_) {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                        if (res.disposition == "attachment") {
                            window.navigator.msSaveOrOpenBlob(blob, res.filename);
                        }
                        else {
                            window.navigator.msSaveBlob(blob, res.filename);
                        }
                    }
                    else {
                        var URL = window.URL || window.webkitURL,
                            downloadUrl = URL.createObjectURL(blob);

                        if (res.filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("A");
                            a.style.display = "none";
                            // safari doesn't support this yet
                            if (typeof a.download === _U_) {
                                if (this.target) {
                                    window.location = downloadUrl;
                                }
                            }
                            else {
                                a.href = downloadUrl;
                                a.download = res.filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }
                        else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function () {
                            URL.revokeObjectURL(downloadUrl);
                        }, 100);
                    }
                    this.result = res;
                });
                return _fetch("download", r, o);
            }
        };
        this.selectDocument = this.document.select;
        this.createDocument = this.document.create;
        this.updateDocument = this.document.update;
        this.deleteDocument = this.document.delete;
        this.downloadDocument = this.document.download;
        //#endregion

        //#region Utility API
        this.utils = {
            getInfo: function (d, o) { return _fetch("utils/getInfo", d, o); },
            ping: function (d, o) { return _fetch("utils/ping", d, o); },
            startPing: function (r) {
                r = r || {};
                var timeout = _int(r.timeout, 0);
                if (timeout < 5000) {
                    timeout = 5000;
                }
                return setInterval(function () {
                    self.ping(r);
                }, timeout);
            },
            cancelPing: function (ping) {
                if (ping) {
                    clearInterval(ping);
                    return true;
                }
                return false;
            },
            execute: function (d, o) { return _fetch("utils/execute", d, o); },
            upload: function (d, o) {
                var data = addDocContent(new FormData(), d, "file");
                data.append(_REQ_, toJson(d));
                return _fetch("utils/upload", data, o);
            }
        };
        //#endregion

        //#region Snapshot API
        this.snapshot = {
            select: function (d, o) { return _fetch("spanshot/select", d, o); },
            create: function (d, o) { return _fetch("spanshot/create", d, o); },
            update: function (d, o) { return _fetch("spanshot/update", d, o); },
            delete: function (d, o) { return _fetch("spanshot/delete", d, o); },
            restore: function (d, o) { return _fetch("spanshot/restore", d, o); }
        };
        //#endregion
    }

    Simgate.version = "0.1.5";
    Simgate.isSimgate = function (o) {
        return (o instanceof Simgate);
    };
    Simgate.Context = SimgateContext;

    return Simgate;
});


//////////////////
// WEBPACK FOOTER
// ./~/trc-simgate/dist/trc.simgate.js
// module id = ./node_modules/trc-simgate/dist/trc.simgate.js
// module chunks = 0